import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../../env/environment';

@Injectable()
export class AuthProvider {
  baseUrl: any;
  constructor(public http: HttpClient) {
    console.log( ENV.API_URL );
    console.log( ENV.QA_URL );

    this.baseUrl = ENV.DEV_URL; //  live
  }


  login(payload){
    return new Promise((resolve,reject) => {
      this.http.post(this.baseUrl + '/login',payload).subscribe(data => {
        resolve(data);
      }, err => {
        reject(err);
        console.log("ERER:",err);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts